/** Fallback only; the report metric catalog remains authoritative when it has an answer. */
export const LOWER_IS_BETTER_FALLBACK = [
  'cost',
  'spend',
  'cpc',
  'cpm',
  'cps',
  'cpi',
  'cpa',
  'cost_per_conversion',
  'cost_per_purchase',
  'bounce_rate',
  'exit_rate',
  'frequency',
] as const
